import { callPost } from '../../services/axios.js'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import {
  CREATE_CP_TEMPLATE,
  UPDATE_CP_TEMPLATE,
} from '../actionTypes/performance.js'

export const loadCpRules = (accessToken, campaignIds) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/performance/loadRules', {
    userId: currentUserId,
    campaignIds,
  }, accessToken).then(response => response.data)
}

export const saveCpRules = (accessToken, campaignIds, status, timezone, slots, templateIds) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/performance/saveRules', {
    userId: currentUserId,
    campaignIds,
    status,
    timezone,
    slots,
    templateIds,
  }, accessToken).then(() => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved rules.',
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save rules.',
    })
  })
}

export const saveCpTemplate = (accessToken, name, slots, needApply = false, campaignIds = []) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/performance/saveTemplate', {
    name,
    slots,
    needApply,
    userId: currentUserId,
    campaignIds,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved template.',
    })

    dispatch({
      type: CREATE_CP_TEMPLATE,
      template: response.data,
    })

    return response.data
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save template.',
    })
    return null
  })
}

export const updateCpTemplate = (accessToken, templateId, name, slots) => (dispatch) => {
  return callPost('/performance/updateTemplate', {
    templateId,
    name,
    slots,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully updated template.',
    })

    dispatch({
      type: UPDATE_CP_TEMPLATE,
      template: response.data,
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to update template.',
    })
  })
}
